import React, { useState, useRef } from "react";
import { useAppStore } from "@/store/appContext";

const KioskInfo: React.FC = () => {
  const { selectedProperty, selectedKiosk, openPropertyKioskSelection } =
    useAppStore();
  const [clickCount, setClickCount] = useState(0);
  const clickTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  if (!selectedProperty || !selectedKiosk) {
    return null;
  }

  const handleClick = () => {
    setClickCount((prev) => prev + 1);

    // Clear existing timeout
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
    }

    // If we've reached 5 clicks, open the modal
    if (clickCount + 1 >= 5) {
      openPropertyKioskSelection();
      setClickCount(0);
      return;
    }

    // Set timeout to reset click count after 3 seconds
    clickTimeoutRef.current = setTimeout(() => {
      setClickCount(0);
    }, 3000);
  };

  return (
    <div className="kiosk-info" onClick={handleClick}>
      <div className="kiosk-info-content">
        <span className="kiosk-value">{selectedProperty.name}</span>
        <span className="kiosk-separator">|</span>
        <span className="kiosk-value">{selectedKiosk.name}</span>
      </div>
    </div>
  );
};

export default KioskInfo;
